import { useQuery } from '@tanstack/react-query'
import { PlayLogService } from '../../services/playlog.service'
import type { GetAllPlayersGameStatsParams } from '@/modules/dashboard/type'
import { DashboardKeys } from '@/modules/dashboard/keys'

export default function useQueryGetAllPlayersGameStats(
	params: GetAllPlayersGameStatsParams,
) {
	return useQuery({
		queryKey: [DashboardKeys.PlayerGameStats, params],
		queryFn: () => PlayLogService.getAllPlayersGameStats(params),
	})
}
